<template>
  <div class="matrix-single-choice">
    <q-table :view="view" :rows="issue.rows" :columns="issue.items" :row-desc="issue.rowDesc" :widths="issue.widths">
      <template v-slot:content="{ row, col }">
        <div class="use-hover" @click="row.value = col.id">
          <el-radio :label="col.id" :name="row.row_id" :value="row.value">
            <span></span>
          </el-radio>
        </div>
      </template>
    </q-table>
    <!--    <matrix-table :rows="issue.rows" :columns="issue.items">
      <template v-slot:content="{ row, col }">
        <div @click="row.value = col.id">
          <el-radio :label="col.id" :name="row.row_id" :value="row.value">
            <span></span>
          </el-radio>
        </div>
      </template>
    </matrix-table>-->
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixTable'
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixSingleChoice',
  components: { QTable, MatrixTable },
  changeExpr: 'isSelectAll',
  computed: {
    isSelectAll() {
      return this.issue.rows.reduce((prev, item) => {
        return prev + '-' + item.value
      }, '')
    }
  },
  methods: {
    changeValue(val, row) {
      row.value = val
    }
  }
}
</script>

<style scoped></style>
